import { Suspense, cloneElement } from "react";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useOutlet, useLocation, ScrollRestoration } from "react-router-dom";


const queryClient = new QueryClient();


export const Root = () => {
    const location = useLocation();
    const outlet = useOutlet();

    return (
        <QueryClientProvider client={queryClient}>
            <TooltipProvider>
                <Toaster />
                <Sonner />
                <ScrollRestoration />
                <div className="relative">
                    <Suspense fallback={<div className="w-full h-screen fixed top-0 left-0 bg-black" />}>
                        <AnimatePresence mode="wait">
                            {outlet && cloneElement(outlet, { key: location.pathname })}
                        </AnimatePresence>
                    </Suspense>
                </div>
            </TooltipProvider>
        </QueryClientProvider>
    )
}
